module.exports = __webpack_public_path__ + "static/img/6introduce.c5cfefcb.jpg";